namespace GeniuzPOS.InitialData {
    export namespace PsCashCouponTypeSerialService {
        export const baseUrl = 'InitialData/PsCashCouponTypeSerial';

        export declare function Create(request: Serenity.SaveRequest<PsCashCouponTypeSerialRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsCashCouponTypeSerialRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsCashCouponTypeSerialRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsCashCouponTypeSerialRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsCashCouponTypeSerial/Create",
            Update = "InitialData/PsCashCouponTypeSerial/Update",
            Delete = "InitialData/PsCashCouponTypeSerial/Delete",
            Retrieve = "InitialData/PsCashCouponTypeSerial/Retrieve",
            List = "InitialData/PsCashCouponTypeSerial/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsCashCouponTypeSerialService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
